import { useEffect, useMemo, useState } from "react";
import "./App.css";
import { BRAND } from "./brand";
import Logo from "./Logo.jsx";

function App() {
  const API_BASE = "https://backend.webmaster-mne.workers.dev";

  const [token, setToken] = useState(localStorage.getItem("token") || "");
  const [currentUser, setCurrentUser] = useState(() => {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  });

  const [loginUsername, setLoginUsername] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);
  const [loginError, setLoginError] = useState("");

  const isLoggedIn = !!token && !!currentUser;
  const role = currentUser?.role || null;

  const canWrite = role === "operator" || role === "admin";
  const canDelete = role === "admin";
  const canManageCatalog = role === "operator" || role === "admin";
  const canManageUsers = role === "admin";
  const isViewer = role === "viewer";

  const [showInspectionForm, setShowInspectionForm] = useState(true);
  const [showUserPanel, setShowUserPanel] = useState(false);
  const [showVehiclePanel, setShowVehiclePanel] = useState(false);
  const [showReportPanel, setShowReportPanel] = useState(false);
const [reportDate, setReportDate] = useState(new Date().toISOString().slice(0, 10));
const [reportData, setReportData] = useState(null);
const [reportMessage, setReportMessage] = useState("");

  const [vlasnik, setVlasnik] = useState("");
  const [ownerPhone, setOwnerPhone] = useState("");
  const [registracija, setRegistracija] = useState("");
  const [datum, setDatum] = useState("");
  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const [year, setYear] = useState("");
  const [vin, setVin] = useState("");
  const [mileage, setMileage] = useState("");
  const [fuel, setFuel] = useState("Benzin");
  const [vehicleCategory, setVehicleCategory] = useState("M1");
  const [vehicleMass, setVehicleMass] = useState("");
  const [engineNumber, setEngineNumber] = useState("");
  const [result, setResult] = useState("PASS");
  const [validUntil, setValidUntil] = useState("");
  const [note, setNote] = useState("");

  const operatorName = currentUser?.full_name || currentUser?.username || "";

  const [inspections, setInspections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState(null);
  const [searchPlate, setSearchPlate] = useState("");
  const [editId, setEditId] = useState(null);
  const [expiryFilter, setExpiryFilter] = useState("all");

  const [manufacturers, setManufacturers] = useState([]);
  const [modelsList, setModelsList] = useState([]);
  const [manufacturerId, setManufacturerId] = useState("");
  const [modelId, setModelId] = useState("");

  const [newManufacturer, setNewManufacturer] = useState("");
  const [newModelName, setNewModelName] = useState("");
  const [newModelManufacturerId, setNewModelManufacturerId] = useState("");
  const [catalogMessage, setCatalogMessage] = useState("");

  const [users, setUsers] = useState([]);
  const [userMessage, setUserMessage] = useState("");
  const [newUsername, setNewUsername] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newFullName, setNewFullName] = useState("");
  const [newUserRole, setNewUserRole] = useState("operator");
  const [resetPasswords, setResetPasswords] = useState({});

  const authFetch = async (path, options = {}) => {
    const headers = {
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`,
    };

    const res = await fetch(`${API_BASE}${path}`, {
      ...options,
      headers,
    });

    if (res.status === 401) {
      handleLogout();
      throw new Error("Sesija je istekla. Prijavi se ponovo.");
    }

    return res;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError("");
    setLoginLoading(true);

    try {
      const res = await fetch(`${API_BASE}/api/login`, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          username: loginUsername,
          password: loginPassword,
        }),
      });

      if (!res.ok) {
        const msg = await res.text();
        setLoginError(msg || "Prijava nije uspjela.");
        return;
      }

      const data = await res.json();
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      setToken(data.token);
      setCurrentUser(data.user);
      setLoginUsername("");
      setLoginPassword("");
      setLoginError("");
    } catch (err) {
      setLoginError("Greška pri prijavi.");
      console.error(err);
    } finally {
      setLoginLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setToken("");
    setCurrentUser(null);
    setInspections([]);
    setStats(null);
    setManufacturers([]);
    setModelsList([]);
    setUsers([]);
  };

  const roleLabel = useMemo(() => {
    if (role === "admin") return "Administrator";
    if (role === "operator") return "Operater";
    if (role === "viewer") return "Direktor";
    return "";
  }, [role]);

  const resetForm = () => {
    setEditId(null);
    setVlasnik("");
    setOwnerPhone("");
    setRegistracija("");
    setDatum("");
    setMake("");
    setModel("");
    setYear("");
    setVin("");
    setMileage("");
    setFuel("Benzin");
    setVehicleCategory("M1");
    setVehicleMass("");
    setEngineNumber("");
    setResult("PASS");
    setValidUntil("");
    setNote("");
    setManufacturerId("");
    setModelId("");
    setModelsList([]);
  };

  const escapeHtml = (s) =>
    String(s ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
function getRegistrationStatus(date) {
  if (!date) return "green";

  const today = new Date();
  const valid = new Date(date);

  const diffTime = valid - today;
  const days = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (days <= 0) return "black";
  if (days <= 15) return "red";
  if (days <= 30) return "yellow";

  return "green";
}

const filteredInspections = [...inspections]
  .filter((r) => {
    const status = getRegistrationStatus(r.valid_until);

    if (expiryFilter === "all") return true;
    if (expiryFilter === "expiring") return status === "red" || status === "yellow";
    if (expiryFilter === "red") return status === "red";
    if (expiryFilter === "yellow") return status === "yellow";
    if (expiryFilter === "green") return status === "green";

    return true;
  })
  .sort((a, b) => {
    const sa = getRegistrationStatus(a.valid_until);
    const sb = getRegistrationStatus(b.valid_until);

    const order = { red: 1, yellow: 2, green: 3, black: 4 };

    return order[sa] - order[sb];
  });

const loadInspections = async () => {
    setLoading(true);
    try {
      const res = await authFetch("/api/inspections");
      const data = await res.json();
      setInspections(data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const loadStats = async () => {
    try {
      const localDay = new Date().toLocaleDateString("en-CA");
      const res = await authFetch(`/api/stats?day=${localDay}`);
      const data = await res.json();
      setStats(data);
    } catch (e) {
      console.error(e);
    }
  };

  const loadManufacturers = async () => {
    try {
      const res = await authFetch("/api/manufacturers");
      const data = await res.json();
      setManufacturers(data);
    } catch (e) {
      console.error(e);
    }
  };

  const loadModels = async (mid) => {
    try {
      if (!mid) {
        setModelsList([]);
        return;
      }
      const res = await authFetch(`/api/models?manufacturer=${mid}`);
      const data = await res.json();
      setModelsList(data);
    } catch (e) {
      console.error(e);
    }
  };

  const loadUsers = async () => {
    if (!canManageUsers) return;
    try {
      const res = await authFetch("/api/users");
      const data = await res.json();
      setUsers(data);
    } catch (e) {
      console.error(e);
      setUserMessage("Ne mogu da učitam korisnike.");
    }
  };
  const loadReport = async () => {
  setReportMessage("");

  try {
    const res = await authFetch(`/api/reports?day=${reportDate}`);
    const data = await res.json();
    setReportData(data);
  } catch (e) {
    console.error(e);
    setReportMessage("Ne mogu da učitam izvještaj.");
  }
};

  const searchInspections = async () => {
    const q = searchPlate.trim();
    if (!q) {
      alert("Unesi registraciju za pretragu");
      return;
    }

    try {
      const res = await authFetch(`/api/search?plate=${encodeURIComponent(q)}`);
      const data = await res.json();
      setInspections(data);
    } catch (e) {
      console.error(e);
      alert("Pretraga nije uspjela.");
    }
  };

  const handleManufacturerChange = async (e) => {
    const mid = e.target.value;
    setManufacturerId(mid);
    setModelId("");
    setModel("");
    await loadModels(mid);
    const m = manufacturers.find((x) => String(x.id) === String(mid));
    setMake(m ? m.name : "");
  };

  const handleModelChange = (e) => {
    const id = e.target.value;
    setModelId(id);
    const m = modelsList.find((x) => String(x.id) === String(id));
    setModel(m ? m.name : "");
  };

  const startEdit = (r) => {
    setEditId(r.id);
    setVlasnik(r.owner_name || "");
    setOwnerPhone(r.owner_phone || "");
    setRegistracija(r.plate || "");
    setDatum(r.inspection_date || "");
    setMake(r.make || "");
    setModel(r.model || "");
    setYear(r.year ?? "");
    setVin(r.vin || "");
    setMileage(r.mileage ?? "");
    setFuel(r.fuel || "Benzin");
    setVehicleCategory(r.vehicle_category || "M1");
    setVehicleMass(r.vehicle_mass ?? "");
    setEngineNumber(r.engine_number || "");
    setResult(r.result || "PASS");
    setValidUntil(r.valid_until || "");
    setNote(r.note || "");
    setManufacturerId("");
    setModelId("");
    setModelsList([]);
    setShowInspectionForm(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      vlasnik: vlasnik.trim(),
      owner_phone: ownerPhone.trim(),
      registracija: registracija.trim().toUpperCase(),
      datum,
      make: make.trim(),
      model: model.trim(),
      year: year === "" ? null : Number(year),
      vin: vin.trim(),
      mileage: mileage === "" ? null : Number(mileage),
      fuel,
      vehicle_category: vehicleCategory,
      vehicle_mass: vehicleMass === "" ? null : Number(vehicleMass),
      engine_number: engineNumber.trim(),
      result,
      valid_until: validUntil,
      note: note.trim(),
      operator: operatorName,
    };

    if (!payload.vlasnik || !payload.registracija || !payload.datum) {
      alert("Popuni obavezna polja: vlasnik, registracija, datum.");
      return;
    }

    const url = editId ? `/api/inspections/${editId}` : "/api/inspections";
    const method = editId ? "PUT" : "POST";

    try {
      const res = await authFetch(url, {
        method,
        headers: { "content-type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const txt = await res.text();
        alert("Greška: " + txt);
        return;
      }

      resetForm();
      await loadInspections();
      await loadStats();
    } catch (e) {
      console.error(e);
      alert("Ne mogu da sačuvam pregled.");
    }
  };

  const deleteInspection = async (id) => {
    const ok = window.confirm("Da li ste sigurni da želite da obrišete zapis?");
    if (!ok) return;

    try {
      const res = await authFetch(`/api/inspections/${id}`, {
        method: "DELETE",
      });

      if (!res.ok) {
        const txt = await res.text();
        alert("Brisanje nije uspjelo: " + txt);
        return;
      }

      await loadInspections();
      await loadStats();
    } catch (e) {
      console.error(e);
      alert("Ne mogu da obrišem zapis.");
    }
  };

  const addManufacturer = async () => {
    setCatalogMessage("");
    const name = newManufacturer.trim();
    if (!name) return;

    try {
      const res = await authFetch("/api/manufacturers", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ name }),
      });

      if (!res.ok) {
        const txt = await res.text();
        setCatalogMessage(txt);
        return;
      }

      setNewManufacturer("");
      setCatalogMessage("Proizvođač dodat.");
      await loadManufacturers();
    } catch (e) {
      console.error(e);
      setCatalogMessage("Greška pri dodavanju proizvođača.");
    }
  };

  const addModel = async () => {
    setCatalogMessage("");
    const name = newModelName.trim();
    if (!name || !newModelManufacturerId) return;

    try {
      const res = await authFetch("/api/models", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          manufacturer_id: Number(newModelManufacturerId),
          name,
        }),
      });

      if (!res.ok) {
        const txt = await res.text();
        setCatalogMessage(txt);
        return;
      }

      setNewModelName("");
      setCatalogMessage("Model dodat.");

      if (String(manufacturerId) === String(newModelManufacturerId)) {
        await loadModels(newModelManufacturerId);
      }
    } catch (e) {
      console.error(e);
      setCatalogMessage("Greška pri dodavanju modela.");
    }
  };

  const addUser = async () => {
    setUserMessage("");

    const payload = {
      username: newUsername.trim(),
      password: newPassword,
      full_name: newFullName.trim(),
      role: newUserRole,
    };

    if (!payload.username || !payload.password || !payload.role) {
      setUserMessage("Popuni korisničko ime, lozinku i ulogu.");
      return;
    }

    try {
      const res = await authFetch("/api/users", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const txt = await res.text();
        setUserMessage(txt);
        return;
      }

      setNewUsername("");
      setNewPassword("");
      setNewFullName("");
      setNewUserRole("operator");
      setUserMessage("Korisnik uspješno dodat.");
      await loadUsers();
    } catch (e) {
      console.error(e);
      setUserMessage("Greška pri dodavanju korisnika.");
    }
  };

  const deleteUser = async (id) => {
    const ok = window.confirm("Da li ste sigurni da želite da obrišete korisnika?");
    if (!ok) return;

    try {
      const res = await authFetch(`/api/users/${id}`, {
        method: "DELETE",
      });

      if (!res.ok) {
        const txt = await res.text();
        setUserMessage(txt);
        return;
      }

      setUserMessage("Korisnik obrisan.");
      await loadUsers();
    } catch (e) {
      console.error(e);
      setUserMessage("Greška pri brisanju korisnika.");
    }
  };

  const resetUserPassword = async (id) => {
    const password = (resetPasswords[id] || "").trim();
    if (!password) {
      setUserMessage("Unesi novu lozinku za reset.");
      return;
    }

    try {
      const res = await authFetch(`/api/users/${id}/reset-password`, {
        method: "PUT",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ password }),
      });

      if (!res.ok) {
        const txt = await res.text();
        setUserMessage(txt);
        return;
      }

      setResetPasswords((prev) => ({ ...prev, [id]: "" }));
      setUserMessage("Lozinka uspješno resetovana.");
    } catch (e) {
      console.error(e);
      setUserMessage("Greška pri resetu lozinke.");
    }
  };

  const printConfirmation = (r) => {
    const logoEl = document.querySelector(".logoWrap img");
    const logoSrc = logoEl ? logoEl.src : "";
    const statusText = r.result === "PASS" ? "ПРОШАО" : "НИЈЕ ПРОШАО";

    const html = `
<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<title>Потврда o техничком прегледу</title>
<style>
body{font-family:Arial;padding:30px;}
.container{max-width:900px;margin:auto;}
.header{display:flex;align-items:center;gap:20px;margin-bottom:20px;}
.logo{width:100px;}
.title{font-size:22px;font-weight:bold;}
.sub{font-size:14px;color:#555;}
.section{margin-top:20px;border:1px solid #ddd;padding:15px;border-radius:8px;}
.section h3{margin-top:0;}
.grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;}
.item{padding:6px 0;}
.label{font-size:12px;color:#666;}
.value{font-weight:bold;}
.status{margin-top:10px;font-weight:bold;font-size:16px;}
.pass{color:green;}
.fail{color:red;}
.footer{margin-top:40px;display:flex;justify-content:space-between;}
.sign{border-top:1px solid black;width:40%;text-align:center;padding-top:5px;}
</style>
</head>
<body>
<div class="container">
<div class="header">
${logoSrc ? `<img class="logo" src="${logoSrc}">` : ""}
<div>
<div class="title">Потврда o техничком прегледу</div>
<div class="sub">${escapeHtml(BRAND.name)} • ${escapeHtml(
      BRAND.place
    )} • Контакт: ${escapeHtml(BRAND.phone)}</div>
<div class="sub">Број потврде: ${escapeHtml(r.certificate_no || "-")}</div>
<div class="status ${r.result === "PASS" ? "pass" : "fail"}">${statusText}</div>
</div>
</div>

<div class="section">
<h3>Власник</h3>
<div class="grid">
<div class="item"><div class="label">Име / фирма</div><div class="value">${escapeHtml(
      r.owner_name || ""
    )}</div></div>
<div class="item"><div class="label">Телефон</div><div class="value">${escapeHtml(
      r.owner_phone || "-"
    )}</div></div>
</div>
</div>

<div class="section">
<h3>Возило</h3>
<div class="grid">
<div class="item"><div class="label">Регистрација</div><div class="value">${escapeHtml(
      r.plate || ""
    )}</div></div>
<div class="item"><div class="label">VIN</div><div class="value">${escapeHtml(
      r.vin || "-"
    )}</div></div>
<div class="item"><div class="label">Марка</div><div class="value">${escapeHtml(
      r.make || "-"
    )}</div></div>
<div class="item"><div class="label">Модел</div><div class="value">${escapeHtml(
      r.model || "-"
    )}</div></div>
<div class="item"><div class="label">Година</div><div class="value">${escapeHtml(
      r.year || "-"
    )}</div></div>
<div class="item"><div class="label">Гориво</div><div class="value">${escapeHtml(
      r.fuel || "-"
    )}</div></div>
<div class="item"><div class="label">Километража</div><div class="value">${escapeHtml(
      r.mileage || "-"
    )}</div></div>
<div class="item"><div class="label">Категорија</div><div class="value">${escapeHtml(
      r.vehicle_category || "-"
    )}</div></div>
<div class="item"><div class="label">Маса</div><div class="value">${escapeHtml(
      r.vehicle_mass || "-"
    )}</div></div>
<div class="item"><div class="label">Број мотора</div><div class="value">${escapeHtml(
      r.engine_number || "-"
    )}</div></div>
</div>
</div>

<div class="section">
<h3>Преглед</h3>
<div class="grid">
<div class="item"><div class="label">Датум прегледа</div><div class="value">${escapeHtml(
      r.inspection_date || ""
    )}</div></div>
<div class="item"><div class="label">Важи до</div><div class="value">${escapeHtml(
      r.valid_until || "-"
    )}</div></div>
<div class="item"><div class="label">Оператер</div><div class="value">${escapeHtml(
      r.operator || "-"
    )}</div></div>
<div class="item"><div class="label">Вријеме уноса</div><div class="value">${escapeHtml(
      r.created_at || ""
    )}</div></div>
</div>
<div style="margin-top:10px">
<div class="label">Напомена</div>
<div class="value">${escapeHtml(r.note || "-")}</div>
</div>
</div>

<div class="footer">
<div class="sign">Оператер</div>
<div class="sign">Одговорно лице</div>
</div>
</div>
<script>window.onload=function(){window.print()}</script>
</body>
</html>
    `;

    const win = window.open("", "_blank");
    win.document.write(html);
    win.document.close();
  };

  useEffect(() => {
  if (!isLoggedIn) return;

  loadInspections();
  loadStats();
  loadManufacturers();
  loadUsers();

  if (role === "admin" || role === "viewer") {
    loadReport();
  }

}, [isLoggedIn]);

  const loginSubtitle = useMemo(
    () => "Prijavi se da pristupiš sistemu tehničkog pregleda",
    []
  );

  if (!isLoggedIn) {
    return (
      <div className="app">
        <header className="header">
          <div className="headerLeft">
            <div className="logoWrap">
              <Logo size={64} />
            </div>

            <div className="brandText">
              <h1>{BRAND.name}</h1>
              <p>{BRAND.tagline}</p>
              <div className="brandMeta">
                <span>{BRAND.place}</span>
                <span>•</span>
                <span>Контакт: {BRAND.phone}</span>
              </div>
            </div>
          </div>
        </header>

        <div className="grid" style={{ gridTemplateColumns: "1fr" }}>
          <section className="card" style={{ maxWidth: 480, margin: "0 auto" }}>
            <div className="cardHeader">
              <h2>Prijava</h2>
            </div>

            <p style={{ color: "#666", marginTop: 0 }}>{loginSubtitle}</p>

            <form className="form" onSubmit={handleLogin}>
              <div className="field">
                <label>Korisničko ime</label>
                <input
                  type="text"
                  value={loginUsername}
                  onChange={(e) => setLoginUsername(e.target.value)}
                  placeholder="npr. admin"
                />
              </div>

              <div className="field">
                <label>Lozinka</label>
                <input
                  type="password"
                  value={loginPassword}
                  onChange={(e) => setLoginPassword(e.target.value)}
                  placeholder="Unesite lozinku"
                />
              </div>

              {loginError && (
                <div style={{ color: "#b71c1c", fontSize: 14 }}>
                  {loginError}
                </div>
              )}

              <div className="actions">
                <button className="btn primary" type="submit" disabled={loginLoading}>
                  {loginLoading ? "Prijava..." : "Prijavi se"}
                </button>
              </div>
            </form>

            <div style={{ marginTop: 18, textAlign: "center", color: "#666", fontSize: 13 }}>
              Design by IvanO
            </div>
          </section>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <header className="header">
        <div className="headerLeft">
          <div className="logoWrap">
            <Logo size={64} />
          </div>

          <div className="brandText">
            <h1>{BRAND.name}</h1>
            <p>{BRAND.tagline}</p>
            <div className="brandMeta">
              <span>{BRAND.place}</span>
              <span>•</span>
              <span>Контакт: {BRAND.phone}</span>
            </div>
          </div>
        </div>

        <div style={{ textAlign: "right" }}>
          <div style={{ fontWeight: 700 }}>{currentUser?.full_name}</div>
          <div style={{ color: "#666", fontSize: 13 }}>{roleLabel}</div>
          <button className="btn" type="button" onClick={handleLogout} style={{ marginTop: 8 }}>
            Odjava
          </button>
        </div>
      </header>

      {(canWrite || canManageUsers || canManageCatalog || role === "admin" || role === "viewer") && (
  <div className="adminToolbar">
          {canWrite && (
            <button
              className="btn secondary"
              type="button"
              onClick={() => setShowInspectionForm(!showInspectionForm)}
            >
              {showInspectionForm ? "Sakrij tehnički pregled" : "Tehnički pregled"}
            </button>
          )}

          {canManageUsers && (
            <button
              className="btn secondary"
              type="button"
              onClick={() => setShowUserPanel(!showUserPanel)}
            >
              {showUserPanel ? "Sakrij operatere" : "Operateri"}
            </button>
          )}

          {canManageCatalog && (
            <button
              className="btn secondary"
              type="button"
              onClick={() => setShowVehiclePanel(!showVehiclePanel)}
            >
              {showVehiclePanel ? "Sakrij katalog vozila" : "Katalog vozila"}
            </button>
          )}
          {(role === "admin" || role === "viewer") && (
  <button
    className="btn secondary"
    type="button"
    onClick={() => setShowReportPanel(!showReportPanel)}
  >
    {showReportPanel ? "Sakrij izvještaje" : "Izvještaji"}
  </button>
)}
        </div>
      )}

      {stats && (
        <div className="dash">
          <div className="dashCard">
            <div className="dashLabel">Registrovano danas</div>
            <div className="dashValue">{stats.total}</div>
            <div className="dashSmall">Datum: {stats.day}</div>
          </div>

          <div className="dashCard">
            <div className="dashLabel">Prošlo danas</div>
            <div className="dashValue">{stats.pass}</div>
          </div>

          <div className="dashCard">
            <div className="dashLabel">Nije prošlo danas</div>
            <div className="dashValue">{stats.fail}</div>
          </div>

          <div className="dashCard">
            <div className="dashLabel">Top operater danas</div>
            <div className="dashValue">
              {stats.byOperator?.[0]?.operator ?? "—"}
            </div>
            <div className="dashSmall">
              {stats.byOperator?.[0]?.n ?? 0} unosa
            </div>
          </div>
        </div>
      )}

      <div className="grid" style={{ gridTemplateColumns: isViewer ? "1fr" : "1fr 1fr" }}>
        {canWrite && showInspectionForm && (
          <section className="card">
            <div className="cardHeader">
              <h2>{editId ? "Izmjena pregleda" : "Novi tehnički pregled"}</h2>
              {editId && <span className="pill">EDIT MODE</span>}
            </div>

            <form className="form" onSubmit={handleSubmit}>
              <div className="field">
                <label>Vlasnik (obavezno)</label>
                <input
                  type="text"
                  value={vlasnik}
                  onChange={(e) => setVlasnik(e.target.value)}
                  placeholder="Ime i prezime / naziv firme"
                />
              </div>

              <div className="field">
                <label>Telefon vlasnika</label>
                <input
                  type="text"
                  value={ownerPhone}
                  onChange={(e) => setOwnerPhone(e.target.value)}
                  placeholder="npr. 068 123 456"
                />
              </div>

              <div className="field">
                <label>Registracija (obavezno)</label>
                <input
                  type="text"
                  value={registracija}
                  onChange={(e) => setRegistracija(e.target.value.toUpperCase())}
                  placeholder="Npr. PVBG708"
                />
              </div>

              <div className="field">
                <label>Datum pregleda (obavezno)</label>
                <input
                  type="date"
                  value={datum}
                  onChange={(e) => setDatum(e.target.value)}
                />
              </div>

              <hr />

              <div className="field">
                <label>Proizvođač</label>
                <select value={manufacturerId} onChange={handleManufacturerChange}>
                  <option value="">— izaberi proizvođača —</option>
                  {manufacturers.map((m) => (
                    <option key={m.id} value={m.id}>
                      {m.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="field">
                <label>Model</label>
                <select
                  value={modelId}
                  onChange={handleModelChange}
                  disabled={!manufacturerId}
                >
                  <option value="">— izaberi model —</option>
                  {modelsList.map((m) => (
                    <option key={m.id} value={m.id}>
                      {m.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="field">
                <label>Godina proizvodnje</label>
                <input
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                  placeholder="npr. 2018"
                />
              </div>

              <div className="field">
                <label>VIN (broj šasije)</label>
                <input
                  value={vin}
                  onChange={(e) => setVin(e.target.value)}
                  placeholder="npr. WVWZZZ..."
                />
              </div>

              <div className="field">
                <label>Kilometraža</label>
                <input
                  value={mileage}
                  onChange={(e) => setMileage(e.target.value)}
                  placeholder="npr. 184000"
                />
              </div>

              <div className="field">
                <label>Gorivo</label>
                <select value={fuel} onChange={(e) => setFuel(e.target.value)}>
                  <option>Benzin</option>
                  <option>Dizel</option>
                  <option>Plin</option>
                  <option>Hibrid</option>
                  <option>Električno</option>
                </select>
              </div>

              <div className="field">
                <label>Kategorija</label>
                <select
                  value={vehicleCategory}
                  onChange={(e) => setVehicleCategory(e.target.value)}
                >
                  <option value="M1">M1</option>
                  <option value="N1">N1</option>
                  <option value="M2">M2</option>
                  <option value="N2">N2</option>
                </select>
              </div>

              <div className="field">
                <label>Masa (kg)</label>
                <input
                  value={vehicleMass}
                  onChange={(e) => setVehicleMass(e.target.value)}
                  placeholder="npr. 1450"
                />
              </div>

              <div className="field">
                <label>Broj motora</label>
                <input
                  value={engineNumber}
                  onChange={(e) => setEngineNumber(e.target.value)}
                  placeholder="opciono"
                />
              </div>

              <hr />

              <div className="field">
                <label>Rezultat</label>
                <select value={result} onChange={(e) => setResult(e.target.value)}>
                  <option value="PASS">PROŠAO</option>
                  <option value="FAIL">NIJE PROŠAO</option>
                </select>
              </div>

              <div className="field">
                <label>Važi do</label>
                <input
                  type="date"
                  value={validUntil}
                  onChange={(e) => setValidUntil(e.target.value)}
                />
              </div>

              <div className="field">
                <label>Operater</label>
                <input value={operatorName} disabled />
              </div>

              <div className="field">
                <label>Napomena</label>
                <textarea
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  rows={3}
                />
              </div>

              <div className="actions">
                <button className="btn primary" type="submit">
                  {editId ? "Sačuvaj izmjene" : "Sačuvaj pregled"}
                </button>

                {editId && (
                  <button className="btn" type="button" onClick={resetForm}>
                    Otkaži
                  </button>
                )}
              </div>
            </form>
          </section>
        )}

        {canManageUsers && showUserPanel && (
          <section className="card">
            <div className="cardHeader">
              <h2>Administracija operatera</h2>
            </div>

            <div className="field">
              <label>Puno ime</label>
              <input
                value={newFullName}
                onChange={(e) => setNewFullName(e.target.value)}
                placeholder="npr. Marko Marković"
              />
            </div>

            <div className="field">
              <label>Korisničko ime</label>
              <input
                value={newUsername}
                onChange={(e) => setNewUsername(e.target.value)}
                placeholder="npr. marko"
              />
            </div>

            <div className="field">
              <label>Lozinka</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Unesite lozinku"
              />
            </div>

            <div className="field">
              <label>Uloga</label>
              <select
                value={newUserRole}
                onChange={(e) => setNewUserRole(e.target.value)}
              >
                <option value="operator">Operater</option>
                <option value="viewer">Direktor</option>
                <option value="admin">Administrator</option>
              </select>
            </div>

            <div className="actions">
              <button className="btn primary" type="button" onClick={addUser}>
                Dodaj korisnika
              </button>
            </div>

            {userMessage && (
              <div style={{ marginTop: 12, color: "#444", fontSize: 14 }}>
                {userMessage}
              </div>
            )}

            <hr style={{ margin: "18px 0" }} />

            <div className="tableWrap">
              <table>
                <thead>
                  <tr>
                    <th style={{ width: 60 }}>ID</th>
                    <th>Korisničko ime</th>
                    <th>Uloga</th>
                    <th>Puno ime</th>
                    <th>Status</th>
                    <th style={{ width: 260 }}>Akcija</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((u) => (
                    <tr key={u.id}>
                      <td>{u.id}</td>
                      <td>{u.username}</td>
                      <td>
                        {u.role === "admin"
                          ? "Administrator"
                          : u.role === "operator"
                          ? "Operater"
                          : "Direktor"}
                      </td>
                      <td>{u.full_name || "-"}</td>
                      <td>{Number(u.is_active) === 1 ? "Aktivan" : "Neaktivan"}</td>
                      <td>
                        <input
                          type="password"
                          placeholder="Nova lozinka"
                          value={resetPasswords[u.id] || ""}
                          onChange={(e) =>
                            setResetPasswords((prev) => ({
                              ...prev,
                              [u.id]: e.target.value,
                            }))
                          }
                          style={{ marginBottom: 8 }}
                        />
                        <div className="actions">
                          <button
                            className="btn secondary"
                            type="button"
                            onClick={() => resetUserPassword(u.id)}
                          >
                            Reset lozinke
                          </button>

                          <button
                            className="btn danger"
                            type="button"
                            onClick={() => deleteUser(u.id)}
                          >
                            Obriši
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}

                  {users.length === 0 && (
                    <tr>
                      <td colSpan="6" className="empty">
                        Nema korisnika
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </section>
        )}

        {canManageCatalog && showVehiclePanel && (
          <section className="card">
            <div className="cardHeader">
              <h2>Katalog vozila</h2>
            </div>

            <div className="field">
              <label>Novi proizvođač</label>
              <input
                value={newManufacturer}
                onChange={(e) => setNewManufacturer(e.target.value)}
                placeholder="npr. Hyundai"
              />
              <div className="actions">
                <button className="btn secondary" type="button" onClick={addManufacturer}>
                  Dodaj proizvođača
                </button>
              </div>
            </div>

            <div className="field">
              <label>Novi model</label>
              <select
                value={newModelManufacturerId}
                onChange={(e) => setNewModelManufacturerId(e.target.value)}
              >
                <option value="">— izaberi proizvođača —</option>
                {manufacturers.map((m) => (
                  <option key={m.id} value={m.id}>
                    {m.name}
                  </option>
                ))}
              </select>

              <input
                style={{ marginTop: 10 }}
                value={newModelName}
                onChange={(e) => setNewModelName(e.target.value)}
                placeholder="npr. Tucson"
              />

              <div className="actions">
                <button className="btn secondary" type="button" onClick={addModel}>
                  Dodaj model
                </button>
              </div>
            </div>

            {catalogMessage && (
              <div style={{ fontSize: 14, color: "#444" }}>{catalogMessage}</div>
            )}
          </section>
        )}
{(role === "admin" || role === "viewer") && showReportPanel && (
  <section className="card">
    <div className="cardHeader">
      <h2>Izvještaji</h2>
    </div>

    <div className="field">
      <label>Datum izvještaja</label>
      <input
        type="date"
        value={reportDate}
        onChange={(e) => setReportDate(e.target.value)}
      />
    </div>

    <div className="actions">
      <button className="btn secondary" type="button" onClick={loadReport}>
        Učitaj izvještaj
      </button>
    </div>

    {reportMessage && (
      <div style={{ marginTop: 10, color: "#444", fontSize: 14 }}>
        {reportMessage}
      </div>
    )}

    {reportData && (
      <>
        <div className="dash" style={{ marginTop: 14 }}>
          <div className="dashCard">
            <div className="dashLabel">Ukupno pregleda</div>
            <div className="dashValue">{reportData.total}</div>
          </div>

          <div className="dashCard">
            <div className="dashLabel">Prošlo</div>
            <div className="dashValue">{reportData.pass}</div>
          </div>

          <div className="dashCard">
            <div className="dashLabel">Nije prošlo</div>
            <div className="dashValue">{reportData.fail}</div>
          </div>

          <div className="dashCard">
            <div className="dashLabel">Pred istekom 30 dana</div>
            <div className="dashValue">{reportData.expiring30}</div>
          </div>

          <div className="dashCard">
            <div className="dashLabel">Pred istekom 15 dana</div>
            <div className="dashValue">{reportData.expiring15}</div>
          </div>
        </div>

        <hr style={{ margin: "18px 0" }} />

        <div className="cardHeader">
          <h2>Po operaterima</h2>
        </div>

        <div className="tableWrap">
          <table>
            <thead>
              <tr>
                <th>Operater</th>
                <th style={{ width: 140 }}>Broj pregleda</th>
              </tr>
            </thead>
            <tbody>
              {reportData.byOperator?.map((r, idx) => (
                <tr key={idx}>
                  <td>{r.operator}</td>
                  <td>{r.n}</td>
                </tr>
              ))}

              {(!reportData.byOperator || reportData.byOperator.length === 0) && (
                <tr>
                  <td colSpan="2" className="empty">
                    Nema podataka
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <hr style={{ margin: "18px 0" }} />

        <div className="cardHeader">
          <h2>Dnevni pregled</h2>
        </div>

        <div className="tableWrap">
          <table>
            <thead>
              <tr>
                <th style={{ width: 60 }}>ID</th>
                <th>Vlasnik</th>
                <th style={{ width: 140 }}>Registracija</th>
                <th style={{ width: 140 }}>Rezultat</th>
                <th style={{ width: 170 }}>Operater</th>
                <th style={{ width: 170 }}>Važi do</th>
              </tr>
            </thead>
            <tbody>
              {reportData.rows?.map((r) => (
                <tr key={r.id}>
                  <td>{r.id}</td>
                  <td>{r.owner_name}</td>
                  <td className="mono">{r.plate}</td>
                  <td>{r.result === "PASS" ? "PROŠAO" : "NIJE PROŠAO"}</td>
                  <td>{r.operator || "-"}</td>
                  <td className="mono">{r.valid_until || "-"}</td>
                </tr>
              ))}

              {(!reportData.rows || reportData.rows.length === 0) && (
                <tr>
                  <td colSpan="6" className="empty">
                    Nema podataka za izabrani datum
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </>
    )}
  </section>
)}
        <section className="card">
          <div className="cardHeader">
            <h2>Pregledi</h2>
            <div className="rightHeader">
              <button className="btn" type="button" onClick={loadInspections}>
                {loading ? "Učitavam..." : "Osvježi"}
              </button>
            </div>
          </div>

          <div className="searchRow">
            <input
              type="text"
              value={searchPlate}
              onChange={(e) => setSearchPlate(e.target.value)}
              placeholder="Pretraga po registraciji…"
            />
            <button className="btn secondary" type="button" onClick={searchInspections}>
              Pretraži
            </button>
            <button className="btn" type="button" onClick={loadInspections}>
              Prikaži sve
            </button>
          </div>
          <div className="filterRow">
  <button
    className={`btn ${expiryFilter === "all" ? "secondary" : ""}`}
    type="button"
    onClick={() => setExpiryFilter("all")}
  >
    Sve
  </button>

  <button
    className={`btn ${expiryFilter === "expiring" ? "secondary" : ""}`}
    type="button"
    onClick={() => setExpiryFilter("expiring")}
  >
    Pred istekom
  </button>

  <button
    className={`btn ${expiryFilter === "red" ? "secondary" : ""}`}
    type="button"
    onClick={() => setExpiryFilter("red")}
  >
    Crveni
  </button>

  <button
    className={`btn ${expiryFilter === "yellow" ? "secondary" : ""}`}
    type="button"
    onClick={() => setExpiryFilter("yellow")}
  >
    Žuti
  </button>

  <button
    className={`btn ${expiryFilter === "green" ? "secondary" : ""}`}
    type="button"
    onClick={() => setExpiryFilter("green")}
  >
    Aktivni
  </button>
</div>

          <div className="tableWrap">
            <table>
              <thead>
                <tr>
                  <th style={{ width: 60 }}>ID</th>
                  <th>Vlasnik</th>
                  <th style={{ width: 140 }}>Registracija</th>
                  <th style={{ width: 140 }}>Datum</th>
                  <th style={{ width: 170 }}>Broj potvrde</th>
                  <th style={{ width: 240 }}>Akcija</th>
                </tr>
              </thead>
              <tbody>
  {filteredInspections.map((r) => (
    <tr
  key={r.id}
  className={
    getRegistrationStatus(r.valid_until) === "red"
      ? "rowRed"
      : getRegistrationStatus(r.valid_until) === "yellow"
      ? "rowYellow"
      : ""
  }
>
      <td>{r.id}</td>
      <td>{r.owner_name}</td>
      <td className="mono">
        {(() => {
          const status = getRegistrationStatus(r.valid_until);

          let cls = "dotGreen";
          if (status === "yellow") cls = "dotYellow";
          if (status === "red") cls = "dotRed";
          if (status === "black") cls = "dotBlack";

          return (
            <>
              <span className={`statusDot ${cls}`}></span>
              {r.plate}
            </>
          );
        })()}
      </td>
      <td className="mono">{r.inspection_date}</td>
      <td className="mono">{r.certificate_no || "-"}</td>
      <td>
                      {canWrite && (
                        <button
                          className="btn"
                          type="button"
                          onClick={() => startEdit(r)}
                        >
                          Izmijeni
                        </button>
                      )}

                      <button
                        className="btn"
                        type="button"
                        onClick={() => printConfirmation(r)}
                      >
                        Štampaj
                      </button>

                      {canDelete && (
                        <button
                          className="btn danger"
                          type="button"
                          onClick={() => deleteInspection(r.id)}
                        >
                          Obriši
                        </button>
                      )}
                    </td>
                  </tr>
                ))}

                {inspections.length === 0 && (
                  <tr>
                    <td colSpan="6" className="empty">
                      Nema podataka
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {isViewer && (
            <div style={{ marginTop: 12, color: "#666", fontSize: 14 }}>
              Ulogovani ste kao direktor. Imate pregled i statistiku, bez izmjena.
            </div>
          )}
        </section>
      </div>

      <footer className="footer">
        <span>{BRAND.name}</span>
        <span>•</span>
        <span>{BRAND.place}</span>
        <span>•</span>
        <span>Контакт: {BRAND.phone}</span>
      </footer>
    </div>
  );
}

export default App;